<template>
  <div class="relative inline-block group">
    <slot />
    <div
      class="absolute left-1/2 bottom-full mb-2 w-auto -translate-x-1/2 rounded-lg bg-black px-2 py-1 text-sm font-semibold text-white shadow-lg opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto group-focus-within:opacity-100 group-focus-within:pointer-events-auto transition-opacity duration-200 whitespace-nowrap text-center"
      role="tooltip"
      v-if="text"
    >
      {{ text }}
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  text: { type: String, required: true },
});
</script> 